export default "__VITE_ASSET__Cg2ebf49__"